<template>
  <hic-list-page :entities="entities" :condition="condition" @load="query" :loading="meta.loading" title="检验危急值" keywordPlaceholder="检验项目名称、床位号" hide-search-dialog>
    <el-table-column label="操作 " key="action" align="center" min-width="60">
      <template #default="{ row }">
        <el-button slot="reference" type="primary" size="mini" icon="el-icon-first-aid-kit" circle plain title="处理" @click="treat(row)"/>
      </template>
    </el-table-column>
    <el-table-column label="状态" prop="state" key="state" align="center" min-width="100" column-key="state">
      <template slot-scope="{ row }">
        <el-tag v-if="row.state == '待接收'" type="info" size="small" hit effect="dark">{{ row.state }}</el-tag>
        <el-tag v-else-if="row.state == '待检验'" type="primary" size="small" hit effect="dark">{{ row.state }}</el-tag>
        <el-tag v-else-if="row.state == '样本拒收'" type="warning" size="small" hit effect="dark">{{ row.state }}</el-tag>
        <el-tag v-else-if="row.state == '报告发出'" type="success" size="small" hit effect="dark">{{ row.state }}</el-tag>
      </template>
    </el-table-column>
    <el-table-column label="床位号" prop="bedNo" key="bedNo" min-width="100"></el-table-column>
    <el-table-column label="患者姓名" prop="patientName" key="patientName" min-width="120"></el-table-column>
    <el-table-column label="性别" prop="patientGender" key="patientGender" align="center" min-width="80">
      <template slot-scope="{ row }">
        {{ row.patientGender | dictText("Gender") }}
      </template>
    </el-table-column>
    <el-table-column label="年龄" prop="patientAge" key="patientAge" align="center" min-width="80"></el-table-column>
    <el-table-column label="检验项目" prop="name" key="name" min-width="260"></el-table-column>
    <el-table-column label="危急值" prop="critical" key="critical"  header-align="center" align="left" min-width="260">
      <template slot-scope="{ row }">
        <el-tag type="danger" size="small" hit effect="plain">{{ row.lisCriticalItem.content }}</el-tag>
      </template>
    </el-table-column>
    <el-table-column label="开嘱医生" prop="issuedDoctorName" key="issuedDoctorName" min-width="100"></el-table-column>
    <el-table-column label="申请时间" prop="issuedTime" key="issuedTime" align="center" min-width="160"></el-table-column>
    <el-table-column label="执行护士" prop="execNurseName" key="execNurseName" min-width="100"></el-table-column>
    <el-table-column label="接收人" prop="lisReceiveUserName" key="lisReceiveUserName" min-width="100"></el-table-column>
    <el-table-column label="接收时间" prop="lisReceiveTime" key="lisReceiveTime" align="center" min-width="160"></el-table-column>
    <el-table-column label="报告发出时间" prop="lisTestReportTime" key="lisTestReportTime" align="center" min-width="160"></el-table-column>

    <treatment :visible.sync="meta.showTreatment" v-model="currentRow" @saved="query"></treatment>
  </hic-list-page>
</template>
<script>
  import { mapGetters } from "sw-hic";
  import api from "./api";
  export default {
    components: {
      treatment: () => import("./treatment"),
    },
    data() {
      return {
        meta: {
          loading: false,
          showTreatment: false,
        },
        condition: {
          sort: "issuedTime",
          asc: false,
          ids: [],
          pageSize: 20,
          pageIndexOnView: 1,
          state: '报告发出',
          ifWarning: true,
          warningType: 2,
        },
        entities: {},
        currentRow: null,
      }
    },
    computed: {
      ...mapGetters(["dictEnum", "user", "setting"]),
    },
    methods: {
      query() {
        this.meta.loading = true;
        api.LisRecord.getWarning(this.condition)
          .then((res) => {
            res.items.forEach(item => {
              item.lisCriticalItem.content = '项目：' + item.lisCriticalItem['NAME']
                                          + '，简称：' + item.lisCriticalItem['ABBRNAME']
                                          + '，状态：' + item.lisCriticalItem['STATUS']
                                          + '，结果：' + item.lisCriticalItem['VALUE']
                                          + '，参考范围：' + item.lisCriticalItem['REVIEWNOTES']
                                          + '，单位：' + item.lisCriticalItem['UNITS'];
            });
            this.$set(this, "entities", res);
          })
          .finally(() => {
            this.meta.loading = false;
          });
      },
      treat(row) {
        this.currentRow = this.$utils.Obj.clone(row);
        this.meta.showTreatment = true;
      },
    }
  }
</script>
<style>
.el-tag {
  white-space: pre-wrap;
  height: auto;
}
</style>